// src/components/ErrorBoundary.js
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Обновим state, чтобы при следующем рендере показать fallback UI
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Можно залогировать ошибку
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Показываем fallback UI
      return (
        <div className="container my-5">
          <h2>Something went wrong.</h2>
          <p>We encountered an unexpected error. Please reload the page or try again later.</p>
        </div>
      );
    }
    // Если ошибки нет — рендерим детей
    return this.props.children; 
  }
}
